import { render, staticRenderFns } from "./APlaceForm.vue?vue&type=template&id=680b3b8e&scoped=true"
import script from "./APlaceForm.vue?vue&type=script&lang=js"
export * from "./APlaceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b3b8e",
  null
  
)

export default component.exports